(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["informations-card-flip"] && !Shopify.designMode) return;
  try {
    
function icfInit(root) {
  if (!root || root.getAttribute('data-icf-ready') === 'true') return;
  root.setAttribute('data-icf-ready', 'true');

  var grid = root.querySelector('.informations-card-flip__grid');
  if (!grid) return;

  var openFlipper = null;

  // Flip au clic (+/-), une seule carte ouverte à la fois
  grid.addEventListener('click', function (event) {
    var plus = event.target.closest('.informations-card-flip__toggle--plus');
    var minus = event.target.closest('.informations-card-flip__toggle--minus');
    if (!plus && !minus) return;

    var flipper = event.target.closest('.informations-card-flip__flipper');
    if (!flipper) return;

    if (plus) {
      if (openFlipper && openFlipper !== flipper) {
        openFlipper.classList.remove('is-flipped');
        var prevPlus = openFlipper.querySelector('.informations-card-flip__toggle--plus');
        if (prevPlus) prevPlus.setAttribute('aria-expanded', 'false');
      }
      flipper.classList.add('is-flipped');
      plus.setAttribute('aria-expanded', 'true');
      openFlipper = flipper;

      var fill = flipper.querySelector('.informations-card-flip__back-fill');
      var backText = flipper.querySelector('.informations-card-flip__back-text');
      if (fill && backText) {
        requestAnimationFrame(function () {
          var max = backText.scrollHeight - backText.clientHeight;
          fill.style.height = (max > 0 ? (backText.scrollTop / max) * 100 : 0) + '%';
        });
      }
    } else if (minus) {
      flipper.classList.remove('is-flipped');
      var plusBtn = flipper.querySelector('.informations-card-flip__toggle--plus');
      if (plusBtn) plusBtn.setAttribute('aria-expanded', 'false');
      if (openFlipper === flipper) openFlipper = null;
    }
  });

  // Barre de progression du slider horizontal (mobile)
  var progressBar = root.querySelector('.informations-card-flip__progress-bar');
  if (progressBar) {
    var updateProgress = function () {
      var max = grid.scrollWidth - grid.clientWidth;
      var ratio = max > 0 ? grid.scrollLeft / max : 0;
      progressBar.style.width = (ratio * 100) + '%';
    };
    grid.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  // Indicateur de scroll vertical dans chaque face arrière (bouton et piste restent fixes)
  var backTexts = root.querySelectorAll('.informations-card-flip__back-text');
  for (var i = 0; i < backTexts.length; i++) {
    (function (backTextEl) {
      var back = backTextEl.closest('.informations-card-flip__back');
      var fillEl = back ? back.querySelector('.informations-card-flip__back-fill') : null;
      if (!fillEl) return;
      backTextEl.addEventListener('scroll', function () {
        var max = backTextEl.scrollHeight - backTextEl.clientHeight;
        var ratio = max > 0 ? backTextEl.scrollTop / max : 0;
        fillEl.style.height = (ratio * 100) + '%';
      }, { passive: true });
    })(backTexts[i]);
  }

  // "Voir plus d'ingrédients"
  var showMoreBtn = root.querySelector('.informations-card-flip__cta-button');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function () {
      grid.classList.add('is-revealing');
      // deux rAF pour laisser le navigateur peindre l'état initial avant de lancer la transition
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          grid.classList.add('is-expanded');
        });
      });
      var ctaWrap = showMoreBtn.closest('.informations-card-flip__cta');
      if (ctaWrap) ctaWrap.style.display = 'none';
    });
  }
}

document.querySelectorAll('.informations-card-flip').forEach(function (root) {
  icfInit(root);
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target && event.target.querySelector
    ? event.target.querySelector('.informations-card-flip')
    : null;
  if (root) icfInit(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-custom"] && !Shopify.designMode) return;
  try {
    
  class SliderCustomComponent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sliderCustomReady === 'true') return;
      this.dataset.sliderCustomReady = 'true';

      this.viewport = this.querySelector('[data-slider-custom-viewport]');
      this.track = this.querySelector('[data-slider-custom-track]');
      this.progressBar = this.querySelector('[data-slider-custom-progress-bar]');

      if (!this.viewport || !this.track) return;

      this.isDragging = false;
      this.didDrag = false;
      this.pointerId = null;
      this.startX = 0;
      this.startScrollLeft = 0;
      this.lastScrollLeft = 0;
      this.lastMoveTime = 0;
      this.velocity = 0;
      this.rafId = null;
      this.suppressNextClick = false;

      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onClickCapture = this.handleClickCapture.bind(this);
      this.onDragStart = this.handleDragStart.bind(this);
      this.updateViewportWidth = this.measureViewportWidth.bind(this);
      this.onViewportScroll = this.updateProgressBar.bind(this);

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('click', this.onClickCapture, true);
      this.viewport.addEventListener('dragstart', this.onDragStart);

      if (this.progressBar) {
        this.viewport.addEventListener('scroll', this.onViewportScroll, { passive: true });
      }

      this.resizeObserver = new ResizeObserver(this.updateViewportWidth);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.viewport);
      window.addEventListener('resize', this.updateViewportWidth, { passive: true });

      this.measureViewportWidth();
      this.updateProgressBar();
    }

    disconnectedCallback() {
      if (!this.viewport) return;

      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.onPointerMove);
      this.viewport.removeEventListener('pointerup', this.onPointerUp);
      this.viewport.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport.removeEventListener('click', this.onClickCapture, true);
      this.viewport.removeEventListener('dragstart', this.onDragStart);
      this.viewport.removeEventListener('scroll', this.onViewportScroll);
      window.removeEventListener('resize', this.updateViewportWidth);

      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    measureViewportWidth() {
      if (!this.viewport) return;

      const viewportLeft = this.viewport.getBoundingClientRect().left;
      const documentWidth = document.documentElement.clientWidth;
      const availableWidth = Math.max(0, documentWidth - viewportLeft);

      this.style.setProperty('--slider-custom-viewport-width', `${availableWidth}px`);
      this.updateProgressBar();
    }

    updateProgressBar() {
      if (!this.progressBar || !this.viewport) return;

      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const ratio = max > 0 ? this.viewport.scrollLeft / max : 0;

      this.progressBar.style.width = `${ratio * 100}%`;
    }

    handlePointerDown(event) {
      /* Sur tactile, on laisse le scroll natif du navigateur gérer l'inertie. */
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      /* Ne pas transformer les contrôles interactifs en poignée de drag. */
      if (event.target.closest('button, input, textarea, select, [contenteditable="true"]')) return;

      if (this.viewport.scrollWidth <= this.viewport.clientWidth + 1) return;

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      this.viewport.classList.remove('is-gliding');
      this.isDragging = true;
      this.didDrag = false;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.viewport.scrollLeft;
      this.lastScrollLeft = this.viewport.scrollLeft;
      this.lastMoveTime = performance.now();
      this.velocity = 0;

      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture(event.pointerId);
    }

    handlePointerMove(event) {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;

      const deltaX = event.clientX - this.startX;

      if (!this.didDrag && Math.abs(deltaX) > 4) {
        this.didDrag = true;
      }

      if (!this.didDrag) return;

      event.preventDefault();

      const nextScrollLeft = this.startScrollLeft - deltaX;
      this.viewport.scrollLeft = nextScrollLeft;

      const now = performance.now();
      const elapsed = Math.max(1, now - this.lastMoveTime);
      const currentScrollLeft = this.viewport.scrollLeft;

      this.velocity = (currentScrollLeft - this.lastScrollLeft) / elapsed;
      this.lastScrollLeft = currentScrollLeft;
      this.lastMoveTime = now;
    }

    handlePointerUp(event) {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;

      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      if (this.didDrag) {
        this.suppressNextClick = true;
        this.startInertia();
      }

      this.pointerId = null;
    }

    handleClickCapture(event) {
      if (!this.suppressNextClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.suppressNextClick = false;
    }

    handleDragStart(event) {
      if (this.isDragging) event.preventDefault();
    }

    startInertia() {
      let frameVelocity = Math.max(-48, Math.min(48, this.velocity * 16));

      if (Math.abs(frameVelocity) < 0.4) {
        this.velocity = 0;
        return;
      }

      this.viewport.classList.add('is-gliding');

      const glide = () => {
        const before = this.viewport.scrollLeft;
        this.viewport.scrollLeft += frameVelocity;
        const after = this.viewport.scrollLeft;

        frameVelocity *= 0.92;

        const hitEdge = Math.abs(after - before) < 0.1;
        const finished = Math.abs(frameVelocity) < 0.35;

        if (hitEdge || finished) {
          this.viewport.classList.remove('is-gliding');
          this.rafId = null;
          return;
        }

        this.rafId = requestAnimationFrame(glide);
      };

      this.rafId = requestAnimationFrame(glide);
    }
  }

  if (!customElements.get('slider-custom-component')) {
    customElements.define('slider-custom-component', SliderCustomComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
